import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUp } from '@fortawesome/free-solid-svg-icons';
import { faFacebookF, faInstagram, faYoutube } from '@fortawesome/free-brands-svg-icons';
import BrandLogo from '../BrandLogo';
import { env } from '../../config/env';
import '../../assets/css/theme.css';
import '../../assets/css/footer.css';

const Footer = () => {
  const [showScroll, setShowScroll] = useState(false);

  useEffect(() => {
    const checkScrollTop = () => {
      setShowScroll(window.scrollY > 300);
    };
    window.addEventListener('scroll', checkScrollTop);
    return () => window.removeEventListener('scroll', checkScrollTop);
  }, []);

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  return (
    <>
      <footer className="fff">

        {/* ── Call-to-action band ── */}
        <div className="fff-cta">
          <div className="fff-container fff-cta-inner">
            <div>
              <p className="ffh-eyebrow ffh-eyebrow--light ffh-eyebrow--left">Fashion Frame</p>
              <h2 className="fff-cta-title">Dressed for every <em>occasion</em>.</h2>
            </div>
            <div className="fff-cta-actions">
              <a href="/products" className="ffh-btn ffh-btn--gold">Shop now</a>
              <a href="/contact" className="ffh-btn ffh-btn--ghost">Contact us</a>
            </div>
          </div>
        </div>

        {/* ── Main columns ── */}
        <div className="fff-main">
          <div className="fff-container fff-grid">

            {/* Brand */}
            <div className="fff-brand">
              <BrandLogo tone="light" />
              <p className="fff-tagline">Curated with intention. Worn with purpose.</p>

              <ul className="fff-social">
                <li>
                  <a href={env.facebookUrl} aria-label="Facebook"><FontAwesomeIcon icon={faFacebookF} /></a>
                </li>
                <li>
                  <a href={env.instagramUrl} aria-label="Instagram"><FontAwesomeIcon icon={faInstagram} /></a>
                </li>
                <li>
                  <a href={env.youtubeUrl} aria-label="YouTube"><FontAwesomeIcon icon={faYoutube} /></a>
                </li>
              </ul>
            </div>

            {/* Quick links */}
            <div>
              <h5 className="fff-heading">Quick Links</h5>
              <ul className="fff-links">
                <li><a href="/pages/about-us">About Us</a></li>
                <li><a href="/pages/privacy-policy">Privacy Policy</a></li>
              </ul>
            </div>

            {/* Support */}
            <div>
              <h5 className="fff-heading">Support</h5>
              <ul className="fff-links">
                <li><a href="/pages/return-policy">Returns</a></li>
                <li><a href="/pages/shipping-policy">Shipping Policy</a></li>
                <li><a href="/contact">Help &amp; Contact</a></li>
                <li><a href="/pages/terms-conditions">Terms &amp; Conditions</a></li>
              </ul>
            </div>

            {/* Contact */}
            <div>
              <h5 className="fff-heading">Contact</h5>
              <div className="fff-contact">
                <span className="fff-contact-label">Email</span>
                <a href={`mailto:${env.supportEmail}`}>{env.supportEmail}</a>
              </div>
              <div className="fff-contact">
                <span className="fff-contact-label">Phone</span>
                <a href={`tel:${env.supportPhone}`}>{env.supportPhoneDisplay}</a>
              </div>
              <div className="fff-contact">
                <span className="fff-contact-label">Address</span>
                <span>{env.companyAddress}.</span>
              </div>
            </div>

          </div>
        </div>

        {/* ── Bottom bar ── */}
        <div className="fff-bottom">
          <div className="fff-container fff-bottom-inner">
            <div className="fff-partners">
              <span className="fff-partners-label">Ships via</span>
              <span className="fff-chip"><img src={require('../../assets/images/SR-logo.png')} alt="Shiprocket" /></span>
              <span className="fff-partners-label">Pay with</span>
              <span className="fff-chip"><img src={require('../../assets/images/razorpay-logo.png')} alt="Razorpay" /></span>
            </div>

            <span className="fff-copy">
              © {new Date().getFullYear()} Fashion Frame. All rights reserved.
            </span>
          </div>
        </div>

      </footer>

      {/* Back to Top */}
      {showScroll && (
        <button
          type="button"
          onClick={scrollToTop}
          className="fff-top"
          aria-label="Back to top"
        >
          <FontAwesomeIcon icon={faArrowUp} />
        </button>
      )}
    </>
  );
};

export default Footer;